

import './unit-detail.component.css';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { Subscription, interval, timer } from 'rxjs';
import { SHARED_IMPORTS } from '../shared/shared-imports';
import { ContentService } from '../../services/content.service';
import { ErrorService } from '../../services/error.service';
import { UiHelperService } from '../../services/ui-helper.service';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';

// Chart.js imports
import {
	Chart,
	registerables,
	TimeScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
	Filler
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import zoomPlugin from 'chartjs-plugin-zoom';
import annotationPlugin from 'chartjs-plugin-annotation';



// Register Chart.js components
Chart.register(
	...registerables,
	TimeScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
	Filler,
	zoomPlugin,
	annotationPlugin
);

@Component({
	selector: 'unit-detail-component',
	standalone: true,
	templateUrl: 'components/unit-detail/unit-detail.component.html',
	styleUrls: ['components/unit-detail/unit-detail.component.css'],
	imports: [
		...SHARED_IMPORTS,
		MatCardModule,
		MatButtonModule,
		MatGridListModule,
		MatProgressBarModule,
		MatIconModule
	],
	providers: [DatePipe],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class UnitDetailComponent implements OnInit, OnDestroy, AfterViewInit {


	public withNavbar = true;
	public plotPeriod = 12;
	public alarms: any[] = [];
	public hasDismissableAlarms = false;
	public hasDismissableAlarmsBtn = true;
	public readMode = false;
	public currentUser: any;
	public temperaturePlotLegend: string;
	public plotLegendNoDataFound: string;
	public humidityPlotLegend: string;
	public scErrors: any[];
	public siteLevelActive: any;

	private currentDataUpdateInterval: number = 60 * 1000; //60 sec
	private errorsGetInterval: number = 60 * 1000;
	private tempData: any[] = [];
	private humidityData: any[] = [];
	private updateCurrentValuesSubscription?: Subscription;
	private updateErrorsSubscription?: Subscription;
	private unitId: string;
	private CagesArray: any[];
	private UnitType: string;
	private YaxisTemperatureMin: number;
	private MinTemperature: number;
	private YaxisTemperatureMax: number;
	private MaxTemperature: number;
	private YaxisHumidityMin: number;
	private YaxisHumidityMax: number;
	private MinHumidity: number;
	private MaxHumidity: number;
	private temperatureChart: Chart | null = null;
	private humidityChart: Chart | null = null;
	
	@ViewChild('temperatureChart', { static: false }) temperatureCanvasRef?: ElementRef<HTMLCanvasElement>;
	@ViewChild('humidityChart', { static: false }) humidityCanvasRef?: ElementRef<HTMLCanvasElement>;
	private SupplyHepaLastDopTestLocalized: any;
	private SupplyHepaLastFilterChangeLocalized: any;
	private ExhaustHepaLastDopTestLocalized: any;
	private ExhaustHepaLastFilterChangeLocalized: any;
	public numberOfDismissableWarnings: number;
	public title: string;
	public LocationInfo: any;
	public LocationName: string;
	public AirChange: any;
	public AirChangeTarget: any;
	public AirFlowDiff: any;
	public AirFlowDiffTarget: any;
	public PressureTarget: any;
	public PressurePa: any;
	public PressurePaTarget: any;
	public UpsPctBattery: any;
	public currentTemperature: any;
	public currentHumidity: any;
	public currentMeasurementTS: any;
	public currentData: any;
	public currentMeasurementTSLocalized: any;
	public currentMeasurementDay: any;
	public currentMeasurementMonth: any;
	public currentMeasurementDate: any;
	public currentMeasurementYear: any;
	public currentMeasurementTime: any;
	public totalHoursSupply: any;
	public usagePercentageSupply: number;
	public totalHoursExhaust: any;
	public usagePercentageExhaust: number;
	public SupplyHepaLifeHours: any;
	public SupplyHepaResidualHours: any;
	public ExhaustHepaLifeHours: any;
	public ExhaustHepaResidualHours: any;
	public MinPressurePa: null;
	public MaxPressurePa: null;
	public MinAirChange: null;
	public MaxAirChange: null;
	public ExhaustAirFlow: null;
	public MinExhaustAirFlow: null;
	public MinUpsPctBattery: null;
	public MinAirFlowDiff: null;
	public MaxAirFlowDiff: null;
	public measurementsInfo: any;
	public unitTypeObj: any;
	public consumableDetails: any;
	public CabinetsArray: any;
	public MixBedFilter: number;
	public alarmGroups: any;

	// Collapse states for Angular replacement of Bootstrap collapse
	public criticalAlarmsCollapsed = true;
	public nonCriticalAlarmsCollapsed = true;
	public dismissableAlarmsCollapsed = true;
	public showMoreCollapsed: { [key: number]: boolean } = {};

	public getContent: (key: string, ...args: any[]) => string;

	private datePipe = inject(DatePipe);
	private content = inject(ContentService);
	private router = inject(Router);
	private route = inject(ActivatedRoute);
	private http = inject(HttpClient);
	private errorService = inject(ErrorService);
	private uiHelper = inject(UiHelperService);

	constructor() {
		// Get route parameters from state service
		this.unitId = this.route.snapshot.params['id'];
	}

	ngOnInit() {
		this.getContent = this.content.getContent.bind(this.content);
		this.plotLegendNoDataFound = this.content.getContent("UnitDetail.NoDataFound");
		this.temperaturePlotLegend = this.content.getContent("UnitDetail.ShowingDataForTheLast12Hours", this.plotPeriod);
		this.humidityPlotLegend = this.temperaturePlotLegend;

		if (this.unitId) {
			this.initUnitId(this.unitId);
		}

		this.getCurrentUser();

		this.updateErrorsSubscription = interval(this.errorsGetInterval).subscribe(() => {
			this.getErrors();
			this.getNotifications();
		});
	}

	ngOnDestroy() {
		if (this.updateCurrentValuesSubscription) {
			this.updateCurrentValuesSubscription.unsubscribe();
		}
		if (this.updateErrorsSubscription) {
			this.updateErrorsSubscription.unsubscribe();
		}
		
		// Destroy Chart.js instances
		if (this.temperatureChart) {
			this.temperatureChart.destroy();
			this.temperatureChart = null;
		}
		if (this.humidityChart) {
			this.humidityChart.destroy();
			this.humidityChart = null;
		}
	}

	ngAfterViewInit() {
		// ViewChild elements are now available
		// Charts will be created when data is loaded via updateCharts()
	}

	getCurrentUser(): void {
		this.http.get<any>('/api/user/CurrentUser').subscribe((result) => {
			this.currentUser = result;
			this.readMode = this.currentUser.GlobalAppRoleId.localeCompare("00000000-0000-0000-0000-000000000004") === 0;
		});
	}
	private fetchSiteLevelStatus(): void {
		this.http.get<any>('/api/Tenant/HasSiteLevel').subscribe((response) => {
			this.siteLevelActive = response;
		});
	}

	private fetchUnitDetails(): void {
		const url = `/api/Unit/Get/${this.unitId}`;
		this.http.get<any>(url).subscribe((response) => {
			const data = response;

			this.title = data.Title;
			this.LocationInfo = data.LocationInfo;
			this.LocationName = data.LocationInfo?.LocationString?.split(" - ")[0] ?? null;

			Object.assign(this, {
				MaxTemperature: data.MaxTemperature,
				MinTemperature: data.MinTemperature,
				MaxHumidity: data.MaxHumidity,
				MinHumidity: data.MinHumidity,
				CageHumidityTarget: data.CageHumidityTarget,
				MaxPressurePa: data.MaxPressurePa,
				MinPressurePa: data.MinPressurePa,
				MinExhaustAirFlow: data.MinExhaustAirFlow,
				MinUpsPctBattery: data.MinUpsPctBattery,
				Cabinets: data.Cabinets,
				CagesArray: data.CagesArray,
				CabinetsArray: data.CabinetsArray,
				ProxyVersion: data.ProxyVersion,
				UnitType: data.UnitType,
				ExhaustAirFlow: data.ExhaustAirFlow,
				SupplyHepaLastDopTest: data.SupplyHepaLastDopTest,
				SupplyHepaLastFilterChange: data.SupplyHepaLastFilterChange,
				SupplyHepaLifeHours: data.SupplyHepaLifeHours,
				SupplyHepaResidualHours: data.SupplyHepaResidualHours,
				ExhaustHepaLastDopTest: data.ExhaustHepaLastDopTest,
				ExhaustHepaLastFilterChange: data.ExhaustHepaLastFilterChange,
				ExhaustHepaLifeHours: data.ExhaustHepaLifeHours,
				ExhaustHepaResidualHours: data.ExhaustHepaResidualHours,
				MaxAirChange: data.MaxAirChange,
				MinAirChange: data.MinAirChange,
				MaxAirFlowDiff: data.MaxAirFlowDiff,
				MinAirFlowDiff: data.MinAirFlowDiff,
				MixBedFilter: data.MixBedFilter
			});

			this.SupplyHepaLastDopTestLocalized = this.datePipe.transform(data.SupplyHepaLastDopTest, 'EEEE, MMMM d, y') || '';
			this.SupplyHepaLastFilterChangeLocalized = this.datePipe.transform(data.SupplyHepaLastFilterChange, 'EEEE, MMMM d, y') || '';
			this.ExhaustHepaLastDopTestLocalized = this.datePipe.transform(data.ExhaustHepaLastDopTest, 'EEEE, MMMM d, y') || '';
			this.ExhaustHepaLastFilterChangeLocalized = this.datePipe.transform(data.ExhaustHepaLastFilterChange, 'EEEE, MMMM d, y') || '';

			// kick off updates
			this.getErrors();
			this.getNotifications();
			this.updateCurrentValues();
			this.updateCharts();

			this.updateCurrentValuesSubscription = interval(this.currentDataUpdateInterval).subscribe(() => {
				this.updateCurrentValues();
			});
		}, (error) => {
			if (this.updateCurrentValuesSubscription) {
				this.updateCurrentValuesSubscription.unsubscribe();
			}
			if (this.updateErrorsSubscription) {
				this.updateErrorsSubscription.unsubscribe();
			}
		});
	}

	private getNotifications(): void {
		this.errorService.getNotifications().then((notifications: any[]) => {
			notifications.forEach((notification: any) => {
				// Note: Notification API would need to be implemented in Angular
				// For now, we'll use browser notification or skip this
				if ('Notification' in window) {
					new Notification(
						this.content.getContent("UnitDetail.NewMessage"),
						{
							body: notification.Message
						}
					);
				}
				this.errorService.setNotificationShown(notification.Id);
			});
		});
	}


	public updateCurrentValues(): void {
		this.http
			.get<any>(`/api/measurements/${this.unitId}/current`)
			.subscribe((response) => {
				const data = response;

				this.AirChange = data.airChange;
				this.AirChangeTarget = data.airChangeTarget;
				this.AirFlowDiff = data.airFlowDiff;
				this.AirFlowDiffTarget = data.airFlowDiffTarget;
				this.PressureTarget = data.pressureTarget;
				this.PressurePa = this.getHumidityValue(data.pressurePa);
				this.PressurePaTarget = data.pressurePaTarget;
				this.UpsPctBattery = data.upsPctBattery;
				this.currentTemperature = this.getTemperatureValue(data.currentTemperature);
				this.currentHumidity = this.getHumidityValue(data.currentHumidity);
				this.currentMeasurementTS = data.currentMeasurementTS;

				this.currentMeasurementTSLocalized = this.datePipe.transform(
					this.currentMeasurementTS,
					'EEEE, MMMM d, y HH:mm:ss'
				) || '';

				this.getTimeLocalised();

				this.currentData = data;

				if (!data.unitDisconnected) {
					// Show update notification using Angular approach
					// This would typically be handled by a service or component state
					// For now, we'll use vanilla JavaScript if the element exists
					const updatedElement = document.getElementById('updated');
					if (updatedElement) {
						updatedElement.style.display = 'block';
						setTimeout(() => {
							updatedElement.style.display = 'none';
						}, 3000);
					}
				}

				this.measurementInfoBlock();
			});
	}

	public measurementInfoBlock(): void {
		this.calculateSupplyHeppaFilterUsage();
		this.calculateExhaustHeppaFilterUsage();

		this.measurementsInfo = [
			{
				title: this.content.getContent("UnitDetail.Pressure"),
				subtitle: "Pa",
				value: this.PressurePa != null ? this.PressurePa + " Pa" : "",
				target: this.getDetailsClass(this.PressurePaTarget, this.PressurePa)
					? this.content.getContent("UnitDetail.Target") + " " + this.PressurePaTarget + " Pa"
					: "",
				min: this.MinPressurePa != null
					? this.content.getContent("UnitDetail.Min") + " " + this.MinPressurePa + " Pa"
					: "",
				max: this.MaxPressurePa != null
					? this.content.getContent("UnitDetail.Max") + " " + this.MaxPressurePa + " Pa"
					: "",
				measurementClass: this.outsideLimits(this.PressurePa, this.MinPressurePa, this.MaxPressurePa)
					? "measurementNumber outsideLimitsText"
					: "measurementNumber",
				unitType: "IsoCage SC+Scantainer",
				lowLimit: this.lowLimits(this.PressurePa, this.MinPressurePa),
				highLimit: this.highLimits(this.PressurePa, this.MaxPressurePa)
			},
			{
				title: this.content.getContent("UnitDetail.AirChange"),
				subtitle: this.content.getContent("UnitDetail.AirChangeTargetUnit"),
				value: this.AirChange + " x",
				target: this.getDetailsClass(this.AirChangeTarget, this.AirChange)
					? this.content.getContent("UnitDetail.Target") + " " + this.AirChangeTarget + " x"
					: "",
				min: this.MinAirChange != null
					? this.content.getContent("UnitDetail.Min") + " " + this.MinAirChange + " x"
					: "",
				max: this.MaxAirChange != null
					? this.content.getContent("UnitDetail.Max") + " " + this.MaxAirChange + " x"
					: "",
				measurementClass: this.outsideLimits(this.AirChange, this.MinAirChange, this.MaxAirChange)
					? "measurementNumber outsideLimitsText"
					: "measurementNumber",
				unitType: "IVC IsoCage SC+Scantainer",
				lowLimit: this.lowLimits(this.AirChange, this.MinAirChange),
				highLimit: this.highLimits(this.AirChange, this.MaxAirChange)
			},
			{
				title: this.content.getContent("UnitDetail.ExhaustAirFlow"),
				subtitle: "M3/H",
				value: this.ExhaustAirFlow != null ? this.ExhaustAirFlow + "  M3/H" : "",
				min: this.MinExhaustAirFlow != null
					? this.content.getContent("UnitDetail.Min") + " " + this.MinExhaustAirFlow + " M3/H"
					: "",
				measurementClass: this.outsideMinLimit(this.ExhaustAirFlow, this.MinExhaustAirFlow)
					? "measurementNumber outsideLimitsText"
					: "measurementNumber",
				unitType: "IsoCage",
				lowLimit: this.lowLimits(this.ExhaustAirFlow, this.MinExhaustAirFlow)
			},
			{
				title: this.content.getContent("UnitDetail.UpsPctBattery"),
				value: this.UpsPctBattery != null ? this.UpsPctBattery + " %" : "",
				min: this.MinUpsPctBattery != null
					? this.content.getContent("UnitDetail.Min") + " " + this.MinUpsPctBattery + " %"
					: "",
				measurementClass: this.outsideMinLimit(this.UpsPctBattery, this.MinUpsPctBattery)
					? "measurementNumber outsideLimitsText"
					: "measurementNumber",
				unitType: "IsoCage",
				lowLimit: this.lowLimits(this.UpsPctBattery, this.MinUpsPctBattery)
			},
			{
				title: this.content.getContent("UnitDetail.AirFlowDiff"),
				subtitle: "%",
				value: this.AirFlowDiff + " %",
				target: this.getDetailsClass(this.AirFlowDiffTarget, this.AirFlowDiff)
					? this.content.getContent("UnitDetail.Target") + " " + this.AirFlowDiffTarget + " %"
					: "",
				min: this.MinAirFlowDiff != null
					? this.content.getContent("UnitDetail.Min") + " " + this.MinAirFlowDiff + " %"
					: "",
				max: this.MaxAirFlowDiff != null
					? this.content.getContent("UnitDetail.Max") + " " + this.MaxAirFlowDiff + " %"
					: "",
				measurementClass: this.outsideLimits(this.AirFlowDiff, this.MinAirFlowDiff, this.MaxAirFlowDiff)
					? "measurementNumber outsideLimitsText"
					: "measurementNumber",
				unitType: "IVC",
				lowLimit: this.lowLimits(this.AirFlowDiff, this.MinAirFlowDiff),
				highLimit: this.highLimits(this.AirFlowDiff, this.MaxAirFlowDiff)
			},
			{
				title: this.content.getContent("UnitDetail.PressureDifference"),
				value: this.PressureTarget === 1
					? this.content.getContent("UnitDetail.Positive")
					: this.content.getContent("UnitDetail.Negative"),
				target: "",
				measurementClass: "measurementText",
				unitType: "IVC"
			},
			{
				title: this.content.getContent("UnitDetail.Cages"),
				value: this.getCages(),
				measurementClass: "cagesValue",
				unitType: "IVC IsoCage"
			},
			{
				title: this.content.getContent("UnitDetail.Cabinets"),
				value: this.getCabinets(),
				measurementClass: "cagesValue",
				unitType: "SC+Scantainer"
			},
			{
				title: this.content.getContent("UnitDetail.LastMeasurement"),
				value: `${this.currentMeasurementDay}, ${this.currentMeasurementMonth} ${this.currentMeasurementDate}, ${this.currentMeasurementYear} ${this.currentMeasurementTime}`,
				update: this.content.getContent("UnitDetail.Updated"),
				measurementClass: this.currentData.unitDisconnected ? "redtext" : "",
				unitType: "IVC IsoCage SC+Scantainer"
			}
		];

		this.unitTypeObj = [
			{
				title: this.content.getContent("UnitDetail.UnitType"),
				value: this.unitTypeDefined()
					? this.content.getContent("UnitType." + this.UnitType)
					: "-",
				measurementClass: "cagesText",
				unitType: "IVC IsoCage SC+Scantainer"
			}
		];

		this.consumableDetails = [
			{
				title: this.content.getContent("UnitDetail.SupplyHepaFilterUsage"),
				valueLifeHours: this.SupplyHepaLifeHours,
				valueResidualHours: this.SupplyHepaResidualHours,
				usedHours: this.usagePercentageSupply,
				totalHours: this.totalHoursSupply,
				measurementClass: "lifeHours supply",
				unitType: "IsoCage"
			},
			{
				title: this.content.getContent("UnitDetail.SupplyHepaLastFilterChange"),
				value: this.SupplyHepaLastFilterChangeLocalized,
				measurementClass: "detailsNotVisible",
				unitType: "IsoCage"
			},
			{
				title: this.content.getContent("UnitDetail.SupplyHepaLastDopTest"),
				value: this.SupplyHepaLastDopTestLocalized,
				measurementClass: "detailsNotVisible",
				unitType: "IsoCage"
			},
			{
				title: this.content.getContent("UnitDetail.ExhaustHepaFilterUsage"),
				valueLifeHours: this.ExhaustHepaLifeHours,
				valueResidualHours: this.ExhaustHepaResidualHours,
				usedHours: this.usagePercentageExhaust,
				totalHours: this.totalHoursExhaust,
				measurementClass: "lifeHours exhaust",
				unitType: "IsoCage"
			},
			{
				title: this.content.getContent("UnitDetail.MixBedFilter"),
				valueLifeHours: this.getMixBedFilterValue(this.MixBedFilter),
				usedHours: this.getMixBedFilterValue(this.MixBedFilter),
				totalHours: "100%",
				subtitle: this.content.getContent("UnitDetail.Percentage"),
				measurementClass: "lifeHours exhaust",
				unitType: "IVC SC+Scantainer"
			},
			{
				title: this.content.getContent("UnitDetail.ExhaustHepaLastFilterChange"),
				value: this.ExhaustHepaLastFilterChangeLocalized,
				measurementClass: "detailsNotVisible",
				unitType: "IsoCage"
			},
			{
				title: this.content.getContent("UnitDetail.ExhaustHepaLastDopTest"),
				value: this.ExhaustHepaLastDopTestLocalized,
				measurementClass: "detailsNotVisible",
				unitType: "IsoCage"
			}
		];
	}

	public getProgressClass(measurement: any): string | undefined {
		if (measurement.unitType !== "IsoCage" && measurement.usedHours > 90) {
			return 'redProgressBar';
		}
	}

	public checkIfEmpty(item: any[] | undefined | null): boolean {
		return Array.isArray(item) && item.some(i =>
			i.value !== "" && i.value !== null && i.valueLifeHours !== null
		);
	}

	public checkNumberOfCages(): string {
		// Return empty string or appropriate CSS class
		return '';
	}


	private getHumidityValue(humidityValue: number): number {
		return Math.round(humidityValue);
	}
	private getTemperatureValue(tempValue: number): string {
		return (Math.round(tempValue * 10) / 10).toFixed(1);
	}

	private getMixBedFilterValue(value: number | null): string | undefined {
		return value !== null ? value.toFixed(1) : undefined;
	}

	private getCages(): string {
		return this.getArray(this.CagesArray);
	}

	private getCabinets(): string {
		return this.getArray(this.CabinetsArray);
	}

	private getArray(items: { Key: string; Value: number }[] = []): string {
		return items.map(item => `${item.Value}x${item.Key}`).join('\n');
	}

	private getDetailsClass(target: number, current: number): boolean {
		return !!(target && target !== current && target !== 0);
	}

	private calculateSupplyHeppaFilterUsage(): void {
		this.totalHoursSupply = this.SupplyHepaLifeHours + this.SupplyHepaResidualHours;
		this.usagePercentageSupply = (this.SupplyHepaLifeHours * 100) / this.totalHoursSupply;
	}

	private calculateExhaustHeppaFilterUsage(): void {
		this.totalHoursExhaust = this.ExhaustHepaLifeHours + this.ExhaustHepaResidualHours;
		this.usagePercentageExhaust = (this.ExhaustHepaLifeHours * 100) / this.totalHoursExhaust;
	}

	private outsideLimits(current: number, min: number, max: number): boolean {
		return min !== null && max !== null && (current < min || current > max);
	}

	private outsideMinLimit(current: number, min: number): boolean {
		return min !== null && current !== null && current < min;
	}

	private highLimits(current: number, max: number): boolean {
		return max !== null && current > max;
	}

	private lowLimits(current: number, min: number): boolean {
		return min !== null && current < min;
	}


	private getTimeLocalised(): void {
		const parts = this.currentMeasurementTSLocalized.split(/[ ,]+/);

		this.currentMeasurementDay = this.content.getContent("UnitDetail." + parts[0]);
		this.currentMeasurementMonth = this.content.getContent("UnitDetail." + parts[1]);
		this.currentMeasurementDate = parts[2];
		this.currentMeasurementYear = parts[3];
		this.currentMeasurementTime = parts[4];
	}




	private setupResizeHandler(): void {
					// Use vanilla JavaScript for window resize
		window.addEventListener('resize', () => {
			// Chart.js handles resize automatically, but we can trigger it manually if needed
			if (this.temperatureChart) {
				this.temperatureChart.resize();
			}
			if (this.humidityChart) {
				this.humidityChart.resize();
			}
		});
	}



	initUnitId(unitId: string): void {
		this.unitId = unitId;
		this.scErrors = [];
		
		// Hide update notification using vanilla JavaScript if the element exists
		const updatedElement = document.getElementById('updated');
		if (updatedElement) {
			updatedElement.style.display = 'none';
		}

		this.fetchSiteLevelStatus();
		this.fetchUnitDetails();
		this.setupResizeHandler();
	}

	public updateCharts(): void {
		var d = this.dateUTC();
		this.http.get<any>('/api/measurements/' + this.unitId + '/' + this.getFromDate(d, this.plotPeriod, d.getMinutes(), d.getSeconds())).subscribe((response) => {
			if (response.temperatureData.length) {
				this.tempData = response.temperatureData;
			} else {
				this.tempData = [''];
				this.temperaturePlotLegend = this.plotLegendNoDataFound;
			}
			if (response.humidityData.length) {
				this.humidityData = response.humidityData;
			} else {
				this.humidityData = [''];
				this.humidityPlotLegend = this.plotLegendNoDataFound;
			}
			this.renderGraph(this.tempData, this.humidityData);
		});
	}


	public renderGraph(tempData: any[], humidityData: any[]): void {
		// Calculate Y-axis ranges
		if (!tempData || tempData.length === 0 || tempData[0][1] == null) {
			this.YaxisTemperatureMin = this.MinTemperature == null ? 18 : this.MinTemperature;
			this.YaxisTemperatureMax = this.MaxTemperature == null ? 26 : this.MaxTemperature;
		} else {
			this.YaxisTemperatureMin = Math.floor(this.getMinMeasurement(this.MinTemperature, tempData)) - 2;
			this.YaxisTemperatureMax = Math.ceil(this.getMaxMeasurement(this.MaxTemperature, tempData)) + 2;
		}
		
		if (!humidityData || humidityData.length === 0 || humidityData[0][1] == null) {
			this.YaxisHumidityMin = this.MinHumidity == null ? 35 : this.MinHumidity;
			this.YaxisHumidityMax = this.MaxHumidity == null ? 75 : this.MaxHumidity;
		} else {
			this.YaxisHumidityMin = Math.floor(this.getMinMeasurement(this.MinHumidity, humidityData) / 5) * 5 - 5;
			this.YaxisHumidityMax = Math.ceil(this.getMaxMeasurement(this.MaxHumidity, humidityData) / 5) * 5 + 5;
		}

		// Destroy existing charts
		if (this.temperatureChart) {
			this.temperatureChart.destroy();
			this.temperatureChart = null;
		}
		if (this.humidityChart) {
			this.humidityChart.destroy();
			this.humidityChart = null;
		}

		// Convert data format for Chart.js (from [timestamp, value] to {x: Date, y: value})
		const convertedTempData = tempData && tempData.length > 0 ? 
			tempData.map(([timestamp, value]) => ({
				x: new Date(timestamp),
				y: value
			})) : [];

		const convertedHumidityData = humidityData && humidityData.length > 0 ? 
			humidityData.map(([timestamp, value]) => ({
				x: new Date(timestamp),
				y: value
			})) : [];

		// Use setTimeout to ensure DOM and ViewChild elements are ready
		setTimeout(() => {
			// Check if ViewChild elements are available
			if (this.temperatureCanvasRef && this.humidityCanvasRef) {
				this.createCharts(convertedTempData, convertedHumidityData);
			} else {
				console.warn('Chart canvas elements not yet available, retrying...');
				// Retry after a longer delay
				setTimeout(() => {
					this.createCharts(convertedTempData, convertedHumidityData);
				}, 500);
			}
		}, 200);
	}

	private createCharts(convertedTempData: any[], convertedHumidityData: any[]): void {
		// Create temperature chart
		const tempCanvas = this.temperatureCanvasRef?.nativeElement;
		if (tempCanvas && tempCanvas.getContext) {
			try {
				// Clear any existing content/loading state
				const ctx = tempCanvas.getContext('2d');
				if (ctx) {
					ctx.clearRect(0, 0, tempCanvas.width, tempCanvas.height);
				}
				
				this.temperatureChart = new Chart(tempCanvas, {
					type: 'line',
					data: {
						datasets: [{
							label: 'Temperature',
							data: convertedTempData as any,
							borderColor: 'rgb(1, 78, 114)',
							backgroundColor: 'transparent',
							borderWidth: 2,
							pointRadius: 0,
							order: 1,  // Lower order = rendered on top
							pointHoverRadius: 4,
							spanGaps: false, // equivalent to breakOnNull: true
							tension: 0 // straight lines
						}]
					},
					options: {
						responsive: true,
						maintainAspectRatio: false,
						animation: {
							duration: 0 // Disable animations to prevent loading states
						},
						interaction: {
							intersect: false,
							mode: 'index'
						},
						scales: {
							x: {
								type: 'time',
								time: {
									unit: 'hour',
									displayFormats: {
										hour: 'HH'
									}
								},
								grid: {
									display: false
								},
								ticks: {
									font: {
										size: 9
									}
								}
							},
							y: {
					min: this.YaxisTemperatureMin,
					max: this.YaxisTemperatureMax,
								ticks: {
									count: 3,
									font: {
										size: 9
									}
								},
								grid: {
									display: true
								}
							}
						},
						plugins: {
							legend: {
								display: false
							},

							tooltip: {
								callbacks: {
									title: (context) => {
										const date = new Date(context[0].parsed.x);
										return date.toLocaleTimeString('en-US', { 
											hour: '2-digit', 
											minute: '2-digit',
											hour12: false 
										});
									},
									label: (context) => {
										return `${context.parsed.y.toFixed(1)}°C`;
									}
								},
								displayColors: false,
								backgroundColor: 'rgba(0, 0, 0, 0.8)',
								titleColor: 'white',
								bodyColor: 'white',
								borderColor: 'rgba(0, 0, 0, 0.8)',
								borderWidth: 1
							},
							annotation: this.MinTemperature && this.MaxTemperature ? {
								annotations: {
																	targetZone: {
									type: 'box',
									yMin: this.MinTemperature,
									yMax: this.MaxTemperature,
									backgroundColor: 'rgba(228, 255, 184, 0.7)',
									borderWidth: 0,
									drawTime: 'beforeDatasetsDraw'  // Draw before datasets (behind the line)
								}
								}
							} : undefined,
							zoom: {
								limits: {
									x: {min: 'original', max: 'original'},
									y: {min: 'original', max: 'original'}
								},
								pan: {
									enabled: true,
									mode: 'xy'
								},
								zoom: {
									wheel: {
										enabled: true
									},
									pinch: {
										enabled: true
									},
									mode: 'xy',
									drag: {
										enabled: false
									},
									onZoomComplete: ({chart}) => {
										// Optional: Add zoom complete callback
									}
								}
							}
						}
					}
				});
			} catch (error) {
				console.error('Failed to create temperature chart:', error);
			}
		} else {
			console.error('Temperature chart canvas not found or not ready');
		}

		// Create humidity chart
		const humidityCanvas = this.humidityCanvasRef?.nativeElement;
		if (humidityCanvas && humidityCanvas.getContext) {
			try {
				// Clear any existing content/loading state
				const ctx = humidityCanvas.getContext('2d');
				if (ctx) {
					ctx.clearRect(0, 0, humidityCanvas.width, humidityCanvas.height);
				}
				
				this.humidityChart = new Chart(humidityCanvas, {
				type: 'line',
				data: {
					datasets: [{
						label: 'Humidity',
						data: convertedHumidityData as any,
						borderColor: 'rgb(1, 78, 114)',
						backgroundColor: 'transparent',
						borderWidth: 2,
						pointRadius: 0,
						order: 1,  // Lower order = rendered on top
						pointHoverRadius: 4,
						spanGaps: false, // equivalent to breakOnNull: true
						tension: 0 // straight lines
					}]
				},
				options: {
					responsive: true,
					maintainAspectRatio: false,
					animation: {
						duration: 0 // Disable animations to prevent loading states
					},
					interaction: {
						intersect: false,
						mode: 'index'
					},
					scales: {
						x: {
							type: 'time',
							time: {
								unit: 'hour',
								displayFormats: {
									hour: 'HH'
								}
							},
							grid: {
								display: false
							},
							ticks: {
								font: {
									size: 9
								}
							}
						},
						y: {
					min: this.YaxisHumidityMin,
					max: this.YaxisHumidityMax,
							ticks: {
								count: 3,
								font: {
									size: 9
								}
							},
							grid: {
								display: true
							}
						}
					},
					plugins: {
						legend: {
							display: false
						},

						tooltip: {
							callbacks: {
								title: (context) => {
									const date = new Date(context[0].parsed.x);
									return date.toLocaleTimeString('en-US', { 
										hour: '2-digit', 
										minute: '2-digit',
										hour12: false 
									});
								},
								label: (context) => {
									return `${context.parsed.y.toFixed(0)}%`;
								}
							},
							displayColors: false,
							backgroundColor: 'rgba(0, 0, 0, 0.8)',
							titleColor: 'white',
							bodyColor: 'white',
							borderColor: 'rgba(0, 0, 0, 0.8)',
							borderWidth: 1
						},
						annotation: this.MinHumidity && this.MaxHumidity ? {
							annotations: {
								targetZone: {
									type: 'box',
									yMin: this.MinHumidity,
									yMax: this.MaxHumidity,
									backgroundColor: 'rgba(228, 255, 184, 0.7)',
									borderWidth: 0,
									drawTime: 'beforeDatasetsDraw'  // Draw before datasets (behind the line)
								}
							}
						} : undefined,
						zoom: {
							limits: {
								x: {min: 'original', max: 'original'},
								y: {min: 'original', max: 'original'}
							},
							pan: {
								enabled: true,
								mode: 'xy'
							},
															zoom: {
									wheel: {
										enabled: true
									},
									pinch: {
										enabled: true
									},
									mode: 'xy',
									drag: {
										enabled: false
									},
									onZoomComplete: ({chart}) => {
										// Optional: Add zoom complete callback
									}
								}
							}
						}
					}
				});
			} catch (error) {
				console.error('Failed to create humidity chart:', error);
			}
		} else {
			console.error('Humidity chart canvas not found or not ready');
		}
	}

	private getMinMeasurement(ruleMin: number | null, data: any[]): number {
		if (!data || data.length === 0) return ruleMin ?? 0;

		const minData = Math.min(...data.map(o => o[1] ?? 100));

		if (ruleMin !== null && ruleMin !== undefined) {
			return Math.min(ruleMin, minData);
		}

		return minData;
	}

	private getMaxMeasurement(ruleMax: number | null, data: any[]): number {
		if (!data || data.length === 0) return ruleMax ?? 100;

		const maxData = Math.max(...data.map(o => o[1]));

		if (ruleMax !== null && ruleMax !== undefined) {
			return Math.max(ruleMax, maxData);
		}

		return maxData;
	}

	public unitTypeDefined(): boolean {
		return this.UnitType !== "" && this.UnitType !== null && typeof (this.UnitType) !== 'undefined';
	}

	private dateUTC(date: Date = new Date()): Date {
		return new Date(
			date.getUTCFullYear(),
			date.getUTCMonth(),
			date.getUTCDate(),
			date.getUTCHours(),
			date.getUTCMinutes(),
			date.getUTCSeconds()
		);
	}

	private getFromDate(
		date: Date,
		minusHours: number,
		minusMinutes: number,
		minusSeconds: number
	): string {
		const d = new Date(date); // clone to avoid mutating input

		d.setHours(d.getHours() - minusHours);
		d.setMinutes(d.getMinutes() - minusMinutes);
		d.setSeconds(d.getSeconds() - minusSeconds);

		return `${d.getFullYear()}${this.pad(d.getMonth() + 1, 2)}${this.pad(d.getDate(), 2)}${this.pad(d.getHours(), 2)}${this.pad(d.getMinutes(), 2)}${this.pad(d.getSeconds(), 2)}`;
	}

	private pad(num: number, size: number): string {
		return num.toString().padStart(size, '0');
	}

	private getErrors(): void {
		this.errorService.get(this.unitId).then((errors: any[]) => {
			errors.forEach((error: any) => this.decorateError(error));

			const seen: Record<string, boolean> = {};
			this.scErrors = errors.filter((error: any) => {
				if (seen[error.SynchId]) return false;
				seen[error.SynchId] = true;
				return true;
			});

			this.getNumberOfDismissablefAlarms();
		});
	}

	private decorateError(error: any): void {
		if (error.EndedTS) {
			this.content.getContentPromise('UnitDetail.AlarmSummaryWithEnd')
				.then((contentVal: string) => {
					error.alarmSummary = this.content.substitute(contentVal, error.AlarmMessageLocal, error.StartedTS, error.EndedTS);
				});
		} else {
			this.content.getContentPromise('UnitDetail.AlarmSummaryWithoutEnd')
				.then((contentVal: string) => {
					error.alarmSummary = this.content.substitute(contentVal, error.AlarmMessageLocal, error.StartedTS, error.EndedTS);
				});
		}

		const deviceKey = error.HardwareDevice?.trim() || error.AlarmMessage;
		this.content.getContentPromise('Alarm.HardwareDevice.' + deviceKey)
			.then((contentVal: string) => {
				error.HardwareDeviceTranslated = contentVal;
			});
	}

	private getNumberOfDismissablefAlarms(): void {
		this.http
			.get<number>(`/api/alarm/GetNumberOfDismissableAlarms?unitId=${this.unitId}`)
			.subscribe((response) => {
				this.numberOfDismissableWarnings = response;
				this.hasDismissableAlarmsFunc();
			});
	}

	private hasDismissableAlarmsFunc(): void {
		this.hasDismissableAlarms =
			typeof this.numberOfDismissableWarnings !== 'undefined' &&
			this.numberOfDismissableWarnings > 0;
	}

	public hasNonCriticalAlarms(): string {
		const count = this.scErrors?.filter(
			(e) => e.AlarmType.Severity === 0 && e.EndedTS == null
		).length ?? 0;

		return count > 0 ? 'alarmVisible' : 'alarmHidden';
	}

	public hasCriticalAlarms(): string {
		const count = this.scErrors?.filter(
			(e) => e.AlarmType.Severity === 10 && e.EndedTS == null
		).length ?? 0;

		return count > 0 ? 'alarmVisible' : 'alarmHidden';
	}

	public dismissAll(): void {
		if (!this.scErrors) return;

		this.scErrors.forEach((err, i) => {
			if (err.EndedTS) {
				this.dismissSingleError(i);
			}
		});
	}



	public dismissSingleError(errorIndex: number | 'group', key?: number): void {
		// Group-level dismissal
		if (errorIndex === 'group' && typeof key === 'number') {
			const group = this.alarms?.[key];
			const id = group?.value?.Id;

			if (!id) return;

			this.http.post(`/api/alarm/dismiss/${id}`, {}).subscribe(() => {
				this.alarms.splice(key, 1);
				this.numberOfDismissableWarnings--;
			});
		}

		// Single error in group
		else if (typeof errorIndex === 'number' && typeof key === 'number') {
			const alarm = this.alarms?.[key]?.listOfAlarmsByGroup?.[errorIndex];
			if (!alarm?.Id) return;

			this.http.post(`/api/alarm/dismiss/${alarm.Id}`, {}).subscribe(() => {
				const group = this.alarms[key];
				group.listOfAlarmsByGroup.splice(errorIndex, 1);
				group.key = (parseInt(group.key, 10) - 1).toString();

				group.btnShowMore = parseInt(group.key, 10) > 0
					? `${this.content.getContent("UnitDetail.Show")} ${group.key} ${this.content.getContent("UnitDetail.Less")}...`
					: '';

				this.numberOfDismissableWarnings--;
			});
		}

		// Fallback to scErrors (backward-compatible with controller logic)
		else if (typeof errorIndex === 'number') {
			const error = this.scErrors?.[errorIndex];
			if (!error?.Id) return;

			this.http.post(`/api/alarm/dismiss/${error.Id}`, {}).subscribe(() => {
				this.scErrors.splice(errorIndex, 1);
				this.numberOfDismissableWarnings--;
			});
		}
	}


	public get hasAnyCriticalAlarms(): boolean {
		return this.scErrors?.some(e => e.AlarmType.Severity === 10 && e.EndedTS == null) ?? false;
	}

	public getStartedTime(isoTimestamp: string): string {
		const [datePart, timePart] = isoTimestamp.split('T');
		const [year, month, day] = datePart.split('-');
		const [hour, minute, second] = timePart.split(':');

		const months = [
			' Jan ', ' Feb ', ' Mar ', ' Apr ', ' May ', ' June ', ' July ',
			' Aug ', ' Sep ', ' Oct ', ' Nov ', ' Dec '
		];

		const monthIndex = parseInt(month, 10);
		const monthName = months[monthIndex - 1] ?? month;

		return `${day}${monthName}${year} at ${hour}:${minute}:${second.substring(0, 2)}`;
	}

	public hasAlarmsFunc(): string {
		const count = this.scErrors?.filter(Boolean).length ?? 0;
		return count > 0 ? 'mar' : 'noMar';
	}

	public getHardwareDeviceTranslated(alarm: any): string {

		if (typeof alarm === 'string') {
			return this.content.getContent('Alarm.HardwareDevice.' + this.trimDotAtEnd(alarm));
		} else if (alarm.value?.HardwareDevice) {
			return this.content.getContent('Alarm.HardwareDevice.' + alarm.value.HardwareDevice);
		} else {
			return this.content.getContent('Alarm.HardwareDevice.' + this.trimDotAtEnd(alarm.value.AlarmMessage));
		}
	}

	private trimDotAtEnd(str: string): string {
		return str.endsWith('.') ? str.slice(0, -1) : str;
	}

	public showMoreOrLess(index: number, alarmKey: number, hardwareDevice: string): void {
		this.toggleShowMore(index, alarmKey, hardwareDevice);
	}

	// Method removed - using direct class binding in template instead
	// [class.showMoreBorder]="j > 0" is more performant than method calls

	public GetAlarmsByGroup(hardwareDevice: string, index: number): void {
		this.http
			.get<any>(`/api/alarm/GetAlarmsByGroup?unitId=${this.unitId}&hardwareDevice=${hardwareDevice}`)
			.subscribe((response) => {
				this.alarms[index].listOfAlarmsByGroup = response;
			});
	}


	public goToLocation(site: string | null, location: string): void {
		const path = this.siteLevelActive && site !== null ? `${site}/${location}` : location;
		this.router.navigate(['/LocationOverview', { path }]);
	}

	public goToSite(location: string): void {
		this.router.navigate(['/LocationOverview', { path: location }]);
	}



	public getAlarmGroups(): void {
		this.alarms = [];
		this.hideMenuCollapses();

		this.http.get<any>(`/api/alarm/GetAlarmGroupsInfo?unitId=${this.unitId}`).subscribe((response) => {
			this.alarmGroups = response;
			for (const key in this.alarmGroups) {
				this.alarms.push({
					key: this.alarmGroups[key].Value,
					value: this.alarmGroups[key].Key,
					listOfAlarmsByGroup: [],
					btnShowMore:
						this.alarmGroups[key].Value > 0
							? `${this.content.getContent("UnitDetail.Show")} ${this.alarmGroups[key].Value} ${this.content.getContent("UnitDetail.More")}...`
							: ""
				});
			}
			// Initialize showMoreCollapsed state for all alarms
			this.alarms.forEach((_, index) => {
				this.showMoreCollapsed[index] = true;
			});
		});
	}

	public dismissAllErrors(): void {
		let counter = 1;
		this.http.post(`/api/alarm/dismissAllForUnit/${this.unitId}`, {}).subscribe(() => {
			while (this.alarms.length > 0) {
				console.log('alarms', this.alarms);
				console.log('numberOfDismissableWarnings', this.numberOfDismissableWarnings);
				console.log('alarms[0].key', this.alarms[0].key);
				console.log('alarms[0].key + 1', this.alarms[0].key + 1);
				this.numberOfDismissableWarnings -= this.alarms[0].key + 1;
				this.alarms.splice(0, 1);
				counter++;
			}

			if (this.numberOfDismissableWarnings === 0) {
				this.hasDismissableAlarmsBtn = false;
				timer(counter * 150).subscribe(() => {
					this.hasDismissableAlarms = false;
				});
			}
		});
	}

	public goBack(): void {
		// Note: Angular Router doesn't have previous state tracking - implement if needed
		// Using browser history as fallback
			window.history.back();
	}

	public numCriticalWarnings(): number {
		return this.scErrors.filter(e => e.AlarmType.Severity === 10 && !e.EndedTS).length;
	}

	public numNoncriticalWarnings(): number {
		return this.scErrors.filter(e => e.AlarmType.Severity === 0 && !e.EndedTS).length;
	}

	public setPlotPeriod(plotPeriod: number): void {
		this.plotPeriod = plotPeriod;
		this.updateChartData();
	}

	private updateChartData(): void {
		const currentDate = this.dateUTC();
		const url = `/api/measurements/${this.unitId}/${this.getFromDate(currentDate, this.plotPeriod, currentDate.getMinutes(), currentDate.getSeconds())}`;
		this.http.get<any>(url).subscribe((response) => {
			this.tempData = response.temperatureData.length ? response.temperatureData : [''];
			this.humidityData = response.humidityData.length ? response.humidityData : [''];

			this.temperaturePlotLegend = this.content.getContent("UnitDetail.ShowingDataForTheLast12Hours", this.plotPeriod);
			this.humidityPlotLegend = this.content.getContent("UnitDetail.ShowingDataForTheLast12Hours", this.plotPeriod);

			// Re-render the graphs with new data
			this.renderGraph(this.tempData, this.humidityData);
		});
	}

	public oldSWVersion(): string {
		return this.content.getContent("UnitDetail.OldSWVersion");
	}

	public doShow(item: string): boolean {
		if (this.unitTypeDefined()) {
			return item.includes(this.UnitType);
		} else {
			return item.includes("IVC");
		}
	}

	public showMixBedFilter(item: string): boolean {
		if (this.unitTypeDefined()) {
			return this.UnitType !== 'IsoCage' ? this.MixBedFilter !== null : true;
		} else {
			return false;
		}
	}

	public isUnitDisconnected(unitOffline: boolean): boolean {
		return unitOffline !== null && unitOffline !== undefined && !unitOffline;
	}

	// Angular methods for collapse functionality
	public toggleCriticalAlarms(): void {
		this.criticalAlarmsCollapsed = !this.criticalAlarmsCollapsed;
		// Hide other menu collapses when opening this one
		this.hideMenuCollapses();
	}

	public toggleNonCriticalAlarms(): void {
		this.nonCriticalAlarmsCollapsed = !this.nonCriticalAlarmsCollapsed;
		// Hide other menu collapses when opening this one
		this.hideMenuCollapses();
	}

	public toggleDismissableAlarms(): void {
		this.dismissableAlarmsCollapsed = !this.dismissableAlarmsCollapsed;
		// Hide other menu collapses when opening this one
		this.hideMenuCollapses();
		// Load alarm groups when expanding
		if (!this.dismissableAlarmsCollapsed) {
			this.getAlarmGroups();
		}
	}

	public toggleShowMore(index: number, alarmKey: number, hardwareDevice: string): void {
		this.showMoreCollapsed[index] = !this.showMoreCollapsed[index];
		// Hide other menu collapses when opening this one
		this.hideMenuCollapses();

		if (!this.showMoreCollapsed[index]) {
			this.GetAlarmsByGroup(hardwareDevice, index);
			this.alarms[index].btnShowMore = alarmKey > 0
				? `${this.content.getContent("UnitDetail.Show")} ${alarmKey} ${this.content.getContent("UnitDetail.Less")}...`
				: '';
		} else {
			this.alarms[index].btnShowMore = alarmKey > 0
				? `${this.content.getContent("UnitDetail.Show")} ${alarmKey} ${this.content.getContent("UnitDetail.More")}...`
				: '';
		}
	}

	private hideMenuCollapses(): void {
		// Hide all menu collapses using Angular state management
		// Since we're managing state with Angular, we just ensure other collapses are closed
		// if needed based on UI requirements
	}

}